import React, { useState } from "react";
import InfoPage from ".";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const res = await fetch('/api/user/request-password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      const json = await res.json();
      
      if (res.ok && json.ok) {
        setSubmitStatus('success');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const belowContent = (
    <>
      <div className="login-left">
        <img src="/house.png" alt="Reset Password" className="login-image" />
        <p className="login-welcome">We'll help you get back in</p>
      </div>

      <div className="login-right">
        <form onSubmit={handleSubmit} className="login-form">
          <h3 className="login-title">Reset Password</h3>
          
          {submitStatus === 'success' ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ color: '#28a745', marginBottom: '16px', fontSize: '18px' }}>
                ✓ Check your email
              </p>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6' }}>
                If an account exists with that email, we've sent password reset instructions.
              </p>
              <div className="login-signup-link-below" style={{ marginTop: '24px' }}>
                <a href="/host-login">Back to Login</a>
              </div>
            </div>
          ) : (
            <>
              <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px', textAlign: 'center', lineHeight: '1.6' }}>
                Enter your email address and we'll send you instructions to reset your password.
              </p>
              
              <div className="login-input-group">
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                  className="login-input" 
                />
                <label className="login-label">Email Address</label>
              </div>

              <button type="submit" disabled={isSubmitting} className="login-submit">
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </button>

              {submitStatus === 'error' && (
                <p className="login-error">
                  Something went wrong. Please try again.
                </p>
              )}
              
              <div className="login-signup-link-below">
                <a href="/host-login">Back to Login</a>
              </div>
            </>
          )}
        </form>
      </div>
    </>
  );

  return <InfoPage title="Reset Password" divider belowContent={belowContent} disableStamps />;
};

export default ForgotPassword;

